import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import EventRow from './EventRow'
import Placeholder from '../common/Placeholder'
import Loader from '../common/loader/legacy-loaders/Op36Loader-web'
import Pagination from '../common/Pagination'

import styles from './Events.module.scss'
import colors from '../../assets/styles/globals.scss'
import { ReactComponent as GolferIcon } from '../../assets/images/common/icons/golfer-half-icon.svg'
import CustomPlaceholder from '../common/CustomPlaceholder'

const EventsList = ({ events, loader, searchTerm, activePage, setActivePage, quickLog }) => {
  const { t } = useTranslation()
  const pageCount = useSelector(state => state.events.pagination?.total_pages)
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)

  if (loader) {
    return (
      <div className='col-md-6 mx-auto'>
        <Loader message={t('events.list.loadingEvents')} />
      </div>
    )
  }

  if (events?.length === 0) {
    if (searchTerm) {
      return (
        <div className='mt-5 w-100'>
          <Placeholder
            title={t('events.list.noEventResultsFound')}
            icon={'fa-search'}
            subtext1={t('events.list.nothingMatchedSearch')}
            subtext2={t('events.list.pleaseTryAgain')}
          />
        </div>
      )
    } else {
      return (
        <CustomPlaceholder
          icon = {<GolferIcon id='golferIcon' fill={colors.lightNavy} width={'64px'} height={'64px'}/>}
          subtext = {t('events.nineHoleEventsPlaceholder')}
          title={t('events.list.no9HoleEventsLogged')}
          guideText = {t('events.list.learnHowToSetupEvent')}
          guideLink = {'https://intercom.help/op-36/en/articles/11145257-how-do-i-set-up-a-9-hole-event-series'}
          buttonText = {t('events.list.quickLogAnEvent')}
          handleAction = {quickLog}
        />
      )
    }
  }

  return (
    <>
      {pageCount > 1 && (
        <Pagination
          pageCount={pageCount}
          activePage={activePage}
          fetchData={(newPage) => setActivePage(newPage)}
        />
      )}
      <div className={pageCount > 1 ? styles.eventsListPaginated : styles.eventsList}>
        {events?.map((event) => (
          <div className='row' key={event.id}>
            <EventRow event={event} timezone={timezone}/>
          </div>
        ))}
      </div>
    </>
  )
}

EventsList.propTypes = {
  quickLog: PropTypes.func,
  events: PropTypes.array,
  loader: PropTypes.bool,
  searchTerm: PropTypes.string,
  activePage: PropTypes.number,
  setActivePage: PropTypes.func,
}

export default EventsList
